import { CustomElement, getHtmlFromUrl } from '@/utils';
import { bus } from '@/bus';

export default class Subscribe extends CustomElement {
  static component = 'b-subscribe';
  form: HTMLFormElement | null = null;
  closeButton: HTMLButtonElement | null = null;
  toggleButtons: HTMLButtonElement[] = [];

  init() {
    this.form = this.$('form');
    this.closeButton = this.$('close-button');
    this.toggleButtons = Array.from(document.querySelectorAll('[data-el="subs-toggle"], [href="#subscribe"]'));

    [
      'barba_leave',
      'cancel',
      'cartToggle',
      'menuToggle'
    ].forEach((event) => {
      bus.on(event as any, () => {
        this.close();
      });
    });

    bus.on('click', (ev) => {
      const withinBoundaries = ev.composedPath().includes(this)
      const withinBoundaries2 = this.toggleButtons.some((btn) => ev.composedPath().includes(btn))

      if (!withinBoundaries && !withinBoundaries2) {
        this.close();
      }
    });

    this.toggleButtons.forEach((btn) => {
      btn.addEventListener('click', (ev) => {
        ev.preventDefault();
        this.hasAttribute('open') ? this.close() : this.open();
      });
    })

    this.closeButton?.addEventListener('click', () => {
      this.close();
    });

    this.form?.addEventListener('submit', (e) => {
      e.preventDefault();
      this.setAttribute('busy', '');

      fetch('/actions/_toolkit/content/csrf')
        .then((res) => res.json())
        .then(({ value, name }) => {
          const data = new URLSearchParams();
          data.append(name, value);
          // @ts-ignore
          for (const pair of new FormData(this.form)) {
            data.append(pair[0], pair[1]);
          }

          fetch(window.location.href, {
            method: 'POST',
            headers: {
              'Cache-Control': 'no-cache',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              'HTTP_X_REQUESTED_WITH': 'XMLHttpRequest',
            },
            body: data,
          })
            .then((r) => r.json())
            .then(() => {
              this.removeAttribute('busy');
              this.setAttribute('success', '');
              setTimeout(() => {
                this.removeAttribute('success');
                this.close();
                setTimeout(( )=> {
                  this.form.reset();
                }, 1000)
              }, 3000);
            }).catch();
      }).catch();
    });
  }

  open() {
    this.setAttribute('open', '');

    if (this.form) {
      const field = this.form.querySelector<HTMLInputElement>('input[name="name"]');
      if (field) {
        setTimeout(() => {
          field.focus();
        }, 1000);
      }
    }
  }

  close() {
    this.removeAttribute('open');
  }
}
